module.exports = __webpack_public_path__ + "static/media/emojis_14.d3201f9b.svg";